import {Component, Input} from '@angular/core';
import {AbstractMissingValueComponent} from '@workflow/components/navigator/missing-value-button/missing-value-button.abstract';
import {WorkflowItemKeyDirective} from '@workflow/directives/workflow-item-key/workflow-item-key.directive';

@Component({
	selector: 'workflow-missing-value-list-item',
	templateUrl: './missing-value-list-item.component.html',
	styleUrls: ['./missing-value-list-item.component.scss']
})
export class MissingValueListItemComponent extends AbstractMissingValueComponent {

	@Input() finishedAndLocked = false;
	@Input() meta: {title?: string};

	constructor(workflowItemKey: WorkflowItemKeyDirective) {
		super(workflowItemKey);
	}
}
